/*@ngInject*/
const QuoteActionsRepository = function ($q, baseSharedPromiseRepository, currentSubmissionModel) {

    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadQuoteActions = function (quoteId) {
        var url = '/rest/Actions?uri=com.firstbest.underwriting.quote.Quote:' + quoteId + '&registrationIdentifier=/Quote/' + quoteId,
            cacheKey = 'quoteActions:' + quoteId;

        if (currentSubmissionModel.hasActionsRegistration('/Quote/' + quoteId)) {
            return $q.resolve(null);
        } else {
            return this.get(cacheKey, url).then(function (responseData) {
                currentSubmissionModel.addActionsRegistration('/Quote/' + quoteId, url);
                return responseData;
            });
        }
    };
};

angular.module('gw-um-submission')
    .service('quoteActionsRepository', QuoteActionsRepository);
